import React from "react"
import { SideTabs } from "shared/tabs"
import {
  SURVEY_CONFIGURATION_BATCHES_TAB_SLUG,
  SURVEY_CONFIGURATION_CONTACTS_TAB_SLUG,
  SURVEY_CONFIGURATION_SETTINGS_TAB_SLUG,
} from "utils/tabSlugHelpers"
import SurveyConfigurationBatchesTab, { BATCHES_HEADING } from "./SurveyConfigurationBatchesTab"
import SurveyConfigurationContactsTab, { CONTACTS_TAB_HEADING } from "./SurveyConfigurationContactsTab"
import SurveyConfigurationSettingsTab, { SETTINGS_HEADING } from "./SurveyConfigurationSettingsTab"

const TABS = [
  {
    title: BATCHES_HEADING,
    slug: SURVEY_CONFIGURATION_BATCHES_TAB_SLUG,
    TabContent: SurveyConfigurationBatchesTab,
  },
  {
    title: CONTACTS_TAB_HEADING,
    slug: SURVEY_CONFIGURATION_CONTACTS_TAB_SLUG,
    TabContent: SurveyConfigurationContactsTab,
  },
  {
    title: SETTINGS_HEADING,
    slug: SURVEY_CONFIGURATION_SETTINGS_TAB_SLUG,
    TabContent: SurveyConfigurationSettingsTab,
  },
]

const SurveyConfigurationTabs = () => (
  <SideTabs tabs={TABS} />
)

export default SurveyConfigurationTabs
